import React from 'react';
import Link from 'gatsby-link';

import styles from './pricing.module.scss';

const PricingBox = (p) => {
  return (
    <div className={styles.pricing__box__panel}>
      <div className={styles.pricing__box__title__panel}>
        {p.title}
      </div>
      <div style={{fontSize : '14px'}}>
        {(p.isLink === true) && <Link style={{textDecoration: 'none' , color : '#5B5379'}} to= {p.linkUrl}>{p.pricing}</Link>}
        {(p.isLink === false) && p.pricing}
      </div>
      <div className={styles.pricing__box__features}>
        <ul style={{
          listStyle: 'none',
          paddingLeft:"2px",
          paddingRight : "2px"
        }}>
          {p.features.map((f, index) => (
              <li style={{fontSize : '14px'}} key={index}>{f}</li>
          ))}
        </ul>
      </div>
    </div>
  )
}
const PricingPage = () => (
  <div className={styles.pricing__page__panel} >
    <PricingBox
      title="Trial" 
      key="1"
      isLink={false}
      linkUrl={""}
      pricing = "Free"
      // description="Get started for free and stay free for serious open-source development."
      features={[
         "Client/Site and Employee Management",
         "Maximum 5 users for 15 days",
         "Employee Tracking",
         "Work Order Management & Escalation",
         "Basic Service Feedback",
         "Language Localization"
      ]}
    />
    <PricingBox
      title="Starter"
      key="2"
      isLink={false}
      linkUrl={""}
      pricing = "&#8377; 1000 per user (Monthly)"
      // description="You are working on private and commercial software projects? Then this is your deal."
      features={[
        "Client/Site and Employee Management",
        "Maximum 10 users per month",
        "Employee Tracking",
        "Work Order Management & Escalation",
        "Basic Service Feedback",
        "Language Localization"
    ]}
    />
    <PricingBox
      title="Professional"
      key="3"
      isLink={true}
      linkUrl={"/contactus"}
      pricing = "Contact us for details"
      // description="For professional software engineers who want to be able to code wherever and whenever they want."
      features={[
        "Client/Site and Employee Management",
        "Unlimited users per month",
        "Employee Tracking",
        "Work Order Management & Escalation",
        "Basic Service Feedback",
        "Language Localization",
        "Asset and Parts Management",
        "Customized Feedback"
      ]}
    />
  </div>
);

export default PricingPage;



// WEBPACK FOOTER //
// ./src/pages/pricing.js